import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Paper, FormControl, Button, TextField,
} from '@material-ui/core';

import Actions from '../actions';

class SearchTherapist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      therapist: '',
    };
  }

    handleChange = (e) => {
      this.setState({ therapist: e.target.value });
    }

    onSubmit = (e) => {
      e.preventDefault();
      this.props.fetchTherapists(this.state.therapist)
        .then(() => {
          const { therapists } = this.props;
          if (!therapists) alert('Therapist not found!');
        });
    }

    render() {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Paper style={{ width: '500px', padding: '50px' }}>
            <h3 style={{ marginTop: 0 }}>Search Therapist</h3>
            <form onSubmit={(e) => { return this.onSubmit(e); }}>
              <FormControl fullWidth>
                <TextField name="therapist" label="Email or Name" value={this.state.therapist} onChange={(e) => { this.handleChange(e); }} />
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '20px' }}>
                <Button variant="contained" type="submit" color="primary">Search</Button>
              </FormControl>
            </form>
          </Paper>
        </div>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    therapists: state.therapist.allTherapists,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchTherapist);
